(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["smilax-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
const planEngine = (() => {
  function number(value, label, min, max, integer = false) {
    if (value === '' || value === null || value === undefined) throw new Error(label);
    const n = Number(value);
    if (!Number.isFinite(n) || n < min || n > max || (integer && !Number.isInteger(n))) throw new Error(label);
    return n;
  }
  function measure(row, references, projects) {
    const quantity = number(row.quantity, 'quantity', 1, 100, true);
    const project = projects.find(p => p.id === row.project);
    if (!project) throw new Error('project');
    if (row.method !== 'measured') {
      const ref = references.find(r => r.id === row.method && r.project === row.project);
      if (!ref) throw new Error('reference');
      return { feet: ref.feet * quantity, quantity, reference: ref.id, path: null, density: 'standard' };
    }
    const densityPasses = { light: 1, standard: 2, full: 3 };
    const density = row.density || 'standard';
    if (!densityPasses[density]) throw new Error('density');
    const passes = number(row.passes, 'passes', 1, 30, true);
    const extra = number(row.extra, 'extra', 0, 2000);
    const reserve = number(row.reserve, 'reserve', 0, 50);
    let path;
    if (project.geometry === 'arch') {
      const h = number(row.height, 'height', 0.1, 200);
      const w = number(row.width, 'width', 0.1, 200);
      path = 2 * h + w;
    } else if (project.geometry === 'circle') {
      path = Math.PI * number(row.diameter, 'diameter', 0.1, 200);
    } else if (project.geometry === 'helix') {
      const h = number(row.height, 'height', 0.1, 200);
      const d = number(row.diameter, 'diameter', 0.1, 200);
      const turns = number(row.turns, 'turns', 1, 100, true);
      path = Math.hypot(h, Math.PI * d * turns);
    } else {
      path = number(row.length, 'length', 0.1, 2000);
    }
    const feet = (path * passes + extra) * quantity * (1 + reserve / 100);
    if (feet > 100000) throw new Error('limit');
    return { feet, quantity, path, passes, extra, reserve, reference: null, density };
  }
  function optimize(required, variants) {
    if (!Number.isFinite(required) || required <= 0 || required > 100000) throw new Error('limit');
    const candidates = variants.filter(v => v.available === true && Number.isSafeInteger(v.priceRaw) && v.priceRaw > 0 && Number.isInteger(v.coverage) && v.coverage > 0 && v.coverage % 10 === 0 && Number.isInteger(v.boxes) && v.boxes > 0 && v.variantId);
    if (!candidates.length) throw new Error('unavailable');
    const target = Math.ceil(required / 10);
    const max = target + Math.max(...candidates.map(v => v.coverage / 10)) - 1;
    const costs = new Float64Array(max + 1).fill(Infinity);
    const counts = new Float64Array(max + 1).fill(Infinity);
    const prev = new Int32Array(max + 1).fill(-1);
    costs[0] = 0; counts[0] = 0;
    for (let c = 1; c <= max; c++) {
      candidates.forEach((v, i) => {
        const from = c - v.coverage / 10;
        if (from < 0 || !Number.isFinite(costs[from])) return;
        const price = costs[from] + v.priceRaw;
        const boxes = counts[from] + v.boxes;
        if (price < costs[c] || (price === costs[c] && boxes < counts[c])) {
          costs[c] = price; counts[c] = boxes; prev[c] = i;
        }
      });
    }
    let best = -1;
    for (let c = target; c <= max; c++) {
      if (!Number.isFinite(costs[c])) continue;
      if (best < 0 || costs[c] < costs[best] || (costs[c] === costs[best] && (counts[c] < counts[best] || (counts[c] === counts[best] && c < best)))) best = c;
    }
    if (best < 0) throw new Error('unavailable');
    const selected = new Map();
    let cursor = best;
    while (cursor > 0) {
      const v = candidates[prev[cursor]];
      if (!v) throw new Error('unavailable');
      const key = String(v.variantId);
      if (!selected.has(key)) selected.set(key, { ...v, quantity: 0 });
      selected.get(key).quantity++;
      cursor -= v.coverage / 10;
    }
    const parts = [...selected.values()];
    return { total: costs[best], coverage: best * 10, coverageMax: parts.reduce((s, p) => s + p.coverageMax * p.quantity, 0), boxes: counts[best], parts };
  }
  function cartItems(plan, properties) {
    return plan.parts.map(p => ({ id: Number(p.variantId), quantity: p.quantity, properties: { ...properties } }));
  }
  return { measure, optimize, cartItems };
})();

function initSmilaxCalculator(root) {
  if (root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const cfg = JSON.parse(root.querySelector('[data-smilax-config]').textContent);
  const ui = cfg.ui;
  const rows = root.querySelector('[data-gc-rows]');
  const results = root.querySelector('[data-gc-results]');
  const projectResults = root.querySelector('[data-gc-projects]');
  const rec = root.querySelector('[data-gc-rec]');
  const buy = root.querySelector('[data-gc-addall]');
  const error = root.querySelector('[data-gc-error]');
  const add = root.querySelector('[data-gc-addrow]');
  let currentPlan = null;
  let currentLines = [];
  let busy = false;
  const text = (tag, value, className) => {
    const el = document.createElement(tag);
    el.textContent = value;
    if (className) el.className = className;
    return el;
  };
  const fmt = n => new Intl.NumberFormat(cfg.locale, { maximumFractionDigits: 1 }).format(n);
  const money = cents => new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency }).format(cents / 100);
  const invalidate = () => {
    currentPlan = null; currentLines = [];
    results.hidden = true; buy.disabled = true; error.textContent = '';
  };
  function field(row, key, value, min, max, step = 'any') {
    const wrap = text('label', '', 'gc-field');
    wrap.append(text('span', ui[key]));
    const input = document.createElement('input');
    input.type = 'number'; input.min = min; input.max = max; input.step = step; input.required = true;
    input.value = value; input.dataset.field = key;
    wrap.append(input); return wrap;
  }
  function updateMethod(row) {
    const id = row.querySelector('[data-gc-project]').value;
    const select = row.querySelector('[data-gc-method]');
    select.replaceChildren();
    cfg.references.filter(r => r.project === id).forEach(r => select.add(new Option(r.label, r.id)));
    select.add(new Option(ui.measured, 'measured'));
    if (id === 'bar') select.value = 'measured';
    rebuildDimensions(row);
  }
  function density(row) {
    return cfg.densities.find(item => item.id === row.querySelector('[data-gc-density]').value) || cfg.densities.find(item => item.id === 'standard');
  }
  function densityLabel(id) {
    const density = cfg.densities.find(item => item.id === id);
    return density ? density.label : ui.standard;
  }
  function rebuildDimensions(row) {
    const project = cfg.projects.find(p => p.id === row.querySelector('[data-gc-project]').value);
    const method = row.querySelector('[data-gc-method]').value;
    const densitySelect = row.querySelector('[data-gc-density]');
    const dimensionFields = row.querySelector('[data-gc-dimensions]');
    const note = row.querySelector('[data-gc-row-note]');
    dimensionFields.replaceChildren();
    if (method !== 'measured') {
      const ref = cfg.references.find(r => r.id === method);
      densitySelect.value = 'standard';
      densitySelect.disabled = true;
      note.textContent = ref.note + ' ' + ui.reference_budget + ' ' + fmt(ref.feet) + ' ft.';
      dimensionFields.hidden = true;
    } else {
      densitySelect.disabled = false;
      dimensionFields.hidden = false;
      if (project.geometry === 'arch') {
        dimensionFields.append(field(row, 'height', '', 0.1, 200), field(row, 'width', '', 0.1, 200));
      } else if (project.geometry === 'circle') {
        dimensionFields.append(field(row, 'diameter', '', 0.1, 200));
      } else if (project.geometry === 'helix') {
        dimensionFields.append(field(row, 'height', '', 0.1, 200), field(row, 'diameter', '', 0.1, 200), field(row, 'turns', '', 1, 100, '1'));
      } else {
        dimensionFields.append(field(row, 'length', '', 0.1, 2000));
      }
      dimensionFields.append(field(row, 'passes', density(row).passes, 1, 30, '1'), field(row, 'extra', 0, 0, 2000), field(row, 'reserve', 0, 0, 50));
      note.textContent = ui.measured_note + ' ' + cfg.hints[project.id];
    }
    invalidate();
  }
  function refreshButtons() {
    rows.querySelectorAll('[data-gc-remove]').forEach(button => { button.hidden = rows.children.length === 1; });
    add.disabled = rows.children.length >= 10;
  }
  function addRow() {
    if (rows.children.length >= 10 || busy) return;
    const row = root.querySelector('[data-gc-row-template]').content.firstElementChild.cloneNode(true);
    const project = row.querySelector('[data-gc-project]');
    cfg.projects.forEach(p => project.add(new Option(p.label, p.id)));
    const density = row.querySelector('[data-gc-density]');
    cfg.densities.forEach(item => density.add(new Option(item.label, item.id, item.id === 'standard', item.id === 'standard')));
    rows.append(row);
    updateMethod(row);
    project.addEventListener('change', () => updateMethod(row));
    row.querySelector('[data-gc-method]').addEventListener('change', () => rebuildDimensions(row));
    density.addEventListener('change', () => {
      const passes = row.querySelector('[data-field="passes"]');
      if (passes) passes.value = density(row).passes;
      invalidate();
    });
    row.querySelector('[data-gc-remove]').addEventListener('click', () => {
      if (rows.children.length <= 1 || busy) return;
      row.remove(); refreshButtons(); invalidate();
    });
    row.addEventListener('input', invalidate);
    row.addEventListener('change', invalidate);
    refreshButtons();
  }
  function calculate() {
    if (busy) return;
    invalidate();
    projectResults.replaceChildren();
    const lines = [];
    try {
      for (const row of rows.children) {
        const controls = [...row.querySelectorAll('input,select')];
        const invalid = controls.find(input => !input.checkValidity());
        if (invalid) { invalid.reportValidity(); invalid.focus(); error.textContent = ui.invalid; return; }
        const values = { project: row.querySelector('[data-gc-project]').value, method: row.querySelector('[data-gc-method]').value, density: row.querySelector('[data-gc-density]').value };
        row.querySelectorAll('[data-field]').forEach(input => { values[input.dataset.field] = input.value; });
        const measured = planEngine.measure(values, cfg.references, cfg.projects);
        const label = cfg.projects.find(p => p.id === values.project).label;
        lines.push({ ...measured, label, method: values.method, values });
      }
      const total = lines.reduce((sum, line) => sum + line.feet, 0);
      const plan = planEngine.optimize(total, cfg.variants);
      lines.forEach(line => {
        const item = text('div', '', 'gc-calc-project');
        item.append(text('strong', line.label + ' × ' + line.quantity), text('b', fmt(line.feet) + ' ft'));
        let note;
        if (line.reference) {
          const ref = cfg.references.find(r => r.id === line.reference);
          note = ref.label + ' · ' + ui.reference_estimate;
        } else {
          note = '(' + fmt(line.path) + ' ft × ' + line.passes + ' ' + ui.passes_short + ' + ' + fmt(line.extra) + ' ft) × ' + line.quantity + ' × ' + fmt(1 + line.reserve / 100) + ' · ' + densityLabel(line.density) + ' · ' + ui.measured_estimate;
        }
        item.append(text('small', note)); projectResults.append(item);
      });
      projectResults.append(text('p', ui.total + ' ' + fmt(total) + ' ft', 'gc-calc__total'));
      const grouped = {};
      plan.parts.forEach(p => { grouped[p.size] = (grouped[p.size] || 0) + p.boxes * p.quantity; });
      root.querySelector('[data-gc-rec-name]').textContent = Object.entries(grouped).map(([size,qty]) => qty + ' × ' + size).join(' + ') + ' · ' + plan.boxes + ' ' + ui.boxes;
      root.querySelector('[data-gc-rec-note]').textContent = ui.material_range + ' ' + plan.coverage + '–' + plan.coverageMax + ' ft. ' + ui.low_end;
      root.querySelector('[data-gc-rec-now]').textContent = money(plan.total);
      const breakdown = root.querySelector('[data-gc-breakdown]');
      breakdown.replaceChildren();
      plan.parts.forEach(p => {
        const item = text('li', p.quantity + ' × ' + p.title + ': ' + money(p.priceRaw * p.quantity) + ' ');
        const link = text('a', ui.view_variant);
        link.href = cfg.productUrl + '?variant=' + p.variantId;
        item.append(link); breakdown.append(item);
      });
      rec.hidden = false; results.hidden = false; buy.disabled = false;
      buy.textContent = ui.add_cart; currentPlan = plan; currentLines = lines;
      results.focus({ preventScroll: true });
    } catch (err) {
      error.textContent = err.message === 'unavailable' ? ui.unavailable : ui.invalid;
    }
  }
  buy.addEventListener('click', async () => {
    if (!currentPlan || busy) return;
    const items = planEngine.cartItems(currentPlan, {
      '_smilax_plan_version': cfg.version,
      'Smilax projects': currentLines.map(l => l.quantity + ' × ' + l.label).join('; ').slice(0, 250),
      'Smilax look': currentLines.map(l => l.label + ': ' + densityLabel(l.density)).join('; ').slice(0, 250),
      'Planning vine feet': fmt(currentLines.reduce((n,l) => n + l.feet, 0))
    });
    busy = true; buy.disabled = true; buy.textContent = ui.adding; error.textContent = '';
    const controls = [...root.querySelectorAll('input,select,button')];
    const disabled = controls.map(el => el.disabled);
    controls.forEach(el => { el.disabled = true; });
    try {
      const response = await fetch(cfg.cartAddUrl + '.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items}) });
      const data = await response.json();
      if (!response.ok || data.status >= 400 || !Array.isArray(data.items)) throw new Error(ui.cart_error);
      window.location.assign(cfg.cartUrl);
    } catch (err) {
      error.textContent = ui.cart_error;
      controls.forEach((el,i) => { el.disabled = disabled[i]; });
      busy = false; buy.disabled = false; buy.textContent = ui.add_cart; refreshButtons();
    }
  });
  add.addEventListener('click', addRow);
  root.querySelector('[data-gc-calculate]').addEventListener('click', calculate);
  root.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.tagName === 'INPUT') { event.preventDefault(); calculate(); }
  });
  addRow();
}
function bootSmilaxCalculators() {
  document.querySelectorAll('[data-gc-calc]').forEach(root => {
    try { initSmilaxCalculator(root); }
    catch (err) {
      const error = root.querySelector('[data-gc-error]');
      if (error) error.textContent = error.dataset.fallback;
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootSmilaxCalculators, { once: true });
else bootSmilaxCalculators();
document.addEventListener('shopify:section:load', bootSmilaxCalculators);

})();

  } catch(e) { console.error(e); }
})();
})();
